/**
 * @author      matthew@zumper.com (Matthew Talamini)
 * @copyright   Copyright (c) 2022, Zumper
 */

import { useTheme } from '@emotion/react'

import { IconProps } from '../../types'

export const Phone = ({ fill, size = 20, stroke, ...rest }: IconProps) => {
  const { colors } = useTheme()
  fill = fill ?? colors.textLightest
  stroke = stroke ?? colors.textLightest
  return (
    <svg
      fill="none"
      height={size}
      viewBox="0 0 20 20"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M4.19885 14.6703C3.05474 13.2389 2.30532 11.5211 2.02803 9.69441C1.96167 9.11655 2.01349 8.5309 2.1802 7.97459C2.34691 7.41829 2.62487 6.90346 2.99646 6.46276C3.36805 6.02207 3.82516 5.66511 4.33881 5.41453C4.85246 5.16396 5.41144 5.02522 5.9803 5.00713C6.23072 4.99307 6.4768 5.07835 6.66722 5.24522C6.85765 5.41208 6.97773 5.64764 7.00243 5.90279L7.16792 7.99266C7.18072 8.16038 7.15171 8.32868 7.08361 8.48183C7.01552 8.63498 6.91056 8.76798 6.77854 8.86841L6.06791 9.42571C5.9204 9.53876 5.80732 9.6923 5.74183 9.86848C5.67635 10.0447 5.66114 10.2362 5.69799 10.4209C5.884 11.2298 6.24676 11.9851 6.75907 12.6302L6.67146 12.5108C7.17093 13.1615 7.8018 13.6944 8.52104 14.0732C8.69626 14.1611 8.89197 14.1975 9.08625 14.1781C9.28054 14.1588 9.46572 14.0846 9.62105 13.9637L10.3219 13.4064C10.4561 13.2947 10.6153 13.219 10.7853 13.186C10.9552 13.1529 11.1306 13.1637 11.2954 13.2173L13.3008 13.8144C13.5333 13.8842 13.732 14.0402 13.8581 14.2519C13.9841 14.4635 14.0283 14.7156 13.9822 14.9589C13.815 15.52 13.5373 16.0403 13.1661 16.4876C12.7949 16.9349 12.3382 17.2998 11.8238 17.5599C11.3095 17.82 10.7486 17.9698 10.1756 17.9999C9.60257 18.0301 9.02956 17.9401 8.49183 17.7354C6.7924 17.0646 5.35126 16.1127 4.19885 14.6703Z"
        stroke={stroke}
        strokeWidth="1.5"
      />
      <path
        d="M14.1322 10.5C14.4645 10.5 14.7577 10.2664 14.7776 9.93468C14.7824 9.85475 14.7848 9.77419 14.7848 9.69306C14.7848 7.49619 13.0039 5.71528 10.8071 5.71528C10.7259 5.71528 10.6453 5.71771 10.5653 5.72251C10.2336 5.74239 10 6.03562 10 6.3679V6.52775C10 6.93036 10.4044 7.21528 10.8071 7.21528C12.1755 7.21528 13.2848 8.32462 13.2848 9.69306C13.2848 10.0956 13.5697 10.5 13.9723 10.5H14.1322Z"
        fill={fill}
      />
      <path
        d="M17.2942 10.5C17.6706 10.5 17.991 10.2169 17.9985 9.84053C17.9995 9.7915 18 9.74235 18 9.69308C18 5.71356 14.774 2.48752 10.7944 2.48752C10.7452 2.48752 10.6961 2.48802 10.647 2.489C10.2707 2.49655 9.98757 2.81691 9.98757 3.19331V3.23461C9.98757 3.66206 10.367 3.98752 10.7944 3.98752C13.9455 3.98752 16.5 6.54199 16.5 9.69308C16.5 10.1206 16.8255 10.5 17.253 10.5H17.2942Z"
        fill={fill}
      />
    </svg>
  )
}
